/**
 * Utility functions for authentication management
 */

import { CookieComponent } from '../../../_metronic/assets/ts/components/_CookieComponent'

/**
 * Logs out the user by clearing authentication data
 * @param redirect - Whether to automatically redirect to login page (default: false)
 */
export const logoutUser = (redirect = false) => {
  // Set a timestamp to track when logout occurred
  localStorage.setItem('logoutTimestamp', Date.now().toString())

  // Remove auth data
  localStorage.removeItem('isAuthorised')
  localStorage.removeItem('user')
  localStorage.removeItem('agentCode')
  localStorage.removeItem('userDetails')

  // Clear session cookie
  CookieComponent.delete('keystone-agent-js-session')

  // If redirect flag is set, redirect to login page with clean URL
  if (redirect) {
    window.location.replace('/agent-application/login')
  }

  return true
}

/**
 * Checks if the user is authenticated
 */
export const isAuthenticated = () => {
  const hasLocalAuth = localStorage.getItem('isAuthorised') === 'true'
  const sessionCookie = CookieComponent.get('keystone-agent-js-session')
  const hasValidSessionCookie = !!sessionCookie

  return hasLocalAuth && hasValidSessionCookie
}
